import { Typography } from "@mui/material";

export const EmailModalTitle = () => {
  return <Typography variant="h4">Envoi d'un email au(x) candidat(s)</Typography>;
};
